var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0H0V14H11V9.34203H5.80713V3.98828H11V0Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4065 3.79989L15.2454 6.72804L12.4065 9.6562L13.2805 10.5557L16.9996 6.72804L13.2805 2.90039L12.4065 3.79989Z",
    fill: "#004899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4689 6.72852H7.81372",
    stroke: "#004899",
    strokeWidth: 1.43244
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bf10c7d27359b9e40ba30a5d331c5967.svg";
export { ForwardRef as ReactComponent };